import React from 'react'
import PropTypes from 'prop-types'
import _ from "lodash"
import Select from 'react-select'

const FieldSelect = props => {
    const {items, placeholder} = props
    const {showSearch} = props.customProps
    return (
        <Select
            // defaultValue={props.selectedKey}
            options={items}
            getOptionValue={item => item.key}
            onChange={e => {
                props.setField(e.key)
            }}
            isSearchable={showSearch}
            placeholder={placeholder}
            className='react-select custom-select-field'
            classNamePrefix='select'
            width={'200px'}
            value={_.find(items, x => x.key === props.selectedKey)}
        />
    )
}

FieldSelect.propTypes = {

}

export default FieldSelect
